import { Answer } from '@components/Consultation/steps/Answer'
import { Form } from '@components/Consultation/steps/Form'
import { Landing } from '@components/Consultation/steps/Landing'
import { Match } from '@components/Consultation/steps/Match'
import { Matching } from '@components/Consultation/steps/Matching'
import { WebsocketWrapper } from '@components/Consultation/WebsocketWrapper'
import React, { useEffect } from 'react'

import { useConsultationStep } from '@/hooks/useConsultationStep'
import { useWebsocket } from '@/hooks/useWebsocket'
import { CONSULTATION_STEPS } from '@/types/consultation'
import { hasServiceSelector } from '@/utils/hasServiceSelector'

import { PhoneNumberPopup } from './components/PhoneNumberPopup'
import { TabBar } from './components/TabBar'

const CONSULTATION_STEPS_COMPONENTS: Record<CONSULTATION_STEPS, React.FC> = {
  [CONSULTATION_STEPS.LANDING]: Landing,
  [CONSULTATION_STEPS.FORM]: Form,
  [CONSULTATION_STEPS.MATCHING]: Matching,
  [CONSULTATION_STEPS.MATCH]: Match,
  [CONSULTATION_STEPS.ANSWER]: Answer
}

const WEB_SOCKET_STEPS: CONSULTATION_STEPS[] = [CONSULTATION_STEPS.MATCHING, CONSULTATION_STEPS.MATCH, CONSULTATION_STEPS.ANSWER]

export const Consultation = () => {
  const { currentConsultationStep } = useConsultationStep()
  const { disconnect } = useWebsocket()

  useEffect(() => {
    return () => {
      disconnect()
    }
  }, [])

  if (!currentConsultationStep) return null

  const Component = CONSULTATION_STEPS_COMPONENTS[currentConsultationStep]

  return (
    <>
      {hasServiceSelector() && <TabBar />}

      {WEB_SOCKET_STEPS.includes(currentConsultationStep) ? (
        //  Steps that use websocket should be wrapped in WebsocketProvider
        <WebsocketWrapper>
          <>
            <Component />
            {[CONSULTATION_STEPS.MATCHING, CONSULTATION_STEPS.MATCH].includes(currentConsultationStep) && <PhoneNumberPopup />}
          </>
        </WebsocketWrapper>
      ) : (
        <Component />
      )}
    </>
  )
}
